<template>
    <x-ajax-dropdown
        :allowEmpty="true"
        :blacklist="blacklist"
        :disabled="isLoading"
        :placeholder="placeholder"
        :query="query"
        :url="`/api/group-statistic-templates`"
        :value="selectedResource"
        @input="handleInput"
        label="label"
        trackBy="id"
    />
</template>

<script>
import axios from "axios";
import { get } from "lodash";
import { emptyPromise, handleGeneralXhrError } from "../helpers";
import XAjaxDropdown from "./XAjaxDropdown.vue";

export default {
    components: { XAjaxDropdown },
    created() {
        this.initSelectedResource();
    },
    data() {
        return {
            isLoading: false,
            selectedResource: null,
        };
    },
    methods: {
        fetchSelectedResource() {
            if (this.valueIsEmpty()) {
                this.selectedResource = null;
                return emptyPromise();
            }
            this.isLoading = true;
            const request = axios
                .get(`/api/group-statistic-templates/${this.value}`)
                .then((response) => {
                    this.selectedResource = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleInput(resource) {
            this.selectedResource = resource;
            if (this.valueIsEmpty()) {
                this.$emit("input", this.defaultParser(resource));
                return;
            }
            this.$emit(
                "input",
                this.valueIsObject() ? resource : get(resource, "id", null)
            );
        },
        initSelectedResource() {
            if (!this.valueIsEmpty() && !this.valueIsObject()) {
                this.fetchSelectedResource();
                return;
            }
            this.selectedResource = this.value;

            // Prevent empty value
            if (!this.selectedResource && !this.allowEmpty) {
                this.isLoading = true;
                const request = axios
                    .get(`/api/group-statistic-templates`, {
                        params: this.query
                    })
                    .then((response) => {
                        this.selectedResource = get(response.data.data, 0, null);
                        this.handleInput(this.selectedResource)
                    });
                return handleGeneralXhrError(request).finally(() => {
                    this.isLoading = false;
                });
            }
        },
        valueIsEmpty() {
            return this.value === null;
        },
        valueIsObject() {
            return typeof this.value === "object";
        },
    },
    props: {
        allowEmpty: {
            type: Boolean,
            required: false,
            default: true,
        },
        blacklist: {
            type: Array,
            required: false,
            default: () => [],
        },
        defaultParser: {
            type: Function,
            required: false,
            default: (data) => data,
        },
        placeholder: {
            type: String,
            required: false,
            default: "Pilih Template",
        },
        query: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        value: {
            type: [Number, Object],
            required: false,
            default: null,
        },
    },
    watch: {
        value: {
            handler() {
                this.initSelectedResource();
            },
            deep: true,
        },
    },
};
</script>